import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramImpactWidget } from '../../models/loyalty-dashboard.model';

const PLACEHOLDER: ProgramImpactWidget = {
  periodLabel: 'Last 90 days',
  addedRevenue: 18420,
  vsExpectedPercent: 9.8,
  rangeLow: 14900,
  rangeHigh: 21800,
  rewardsRedeemed: 2310,
  peerDescriptor: 'similar taquerias',
  sinceJoining: 31960,
  returnOnPlanCost: 6.1,
  comparedAgainst: '41 taquerias nationwide',
};

@Component({
  selector: 'app-program-impact-widget',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="impact" *ngIf="data ?? placeholder as w">
      <div class="impact__main">
        <p class="impact__eyebrow">Revenue loyalty added · {{ w.periodLabel }}</p>

        <div class="impact__headline">
          <span class="impact__amount">{{ w.addedRevenue | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
          <span class="impact__delta" *ngIf="w.vsExpectedPercent != null">
            {{ w.vsExpectedPercent > 0 ? '+' : '' }}{{ w.vsExpectedPercent | number : '1.0-1' }}% vs. expected
          </span>
        </div>

        <p class="impact__explain">
          <ng-container *ngIf="w.rangeLow != null && w.rangeHigh != null">
            Likely range {{ w.rangeLow | currency : 'USD' : 'symbol' : '1.0-0' }} –
            {{ w.rangeHigh | currency : 'USD' : 'symbol' : '1.0-0' }}.
          </ng-container>
          This is revenue above what {{ w.peerDescriptor || 'similar businesses' }} saw over the same weeks<ng-container
            *ngIf="w.rewardsRedeemed != null"
            >, after subtracting {{ w.rewardsRedeemed | currency : 'USD' : 'symbol' : '1.0-0' }} in rewards
            redeemed</ng-container
          >.
        </p>

        <a class="impact__link" href="#" (click)="$event.preventDefault()">How we calculate this</a>
      </div>

      <div class="impact__rail">
        <div class="impact__stat" *ngIf="w.sinceJoining != null">
          <span class="impact__stat-label">Since joining</span>
          <span class="impact__stat-value">{{ w.sinceJoining | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
        </div>
        <div class="impact__stat" *ngIf="w.returnOnPlanCost != null">
          <span class="impact__stat-label">Return on plan cost</span>
          <span class="impact__stat-value">{{ w.returnOnPlanCost | number : '1.1-1' }}×</span>
        </div>
        <div class="impact__stat" *ngIf="w.comparedAgainst">
          <span class="impact__stat-label">Compared against</span>
          <span class="impact__stat-value impact__stat-value--text">{{ w.comparedAgainst }}</span>
        </div>
      </div>
    </div>
  `,
  styleUrl: './program-impact-widget.component.scss',
})
export class ProgramImpactWidgetComponent {
  @Input() data: ProgramImpactWidget | null = null;

  protected readonly placeholder = PLACEHOLDER;
}
